export interface PrefernceType {
  locale: string;
  currency: string;
  devMode?: boolean;
  currencyFormatConfig?: CurrencyFormatConfig;
}

export type CurrencyFormatConfig = Record<string, CurrencyConfig>;

export const enum CurrencyPosition {
  BEFORE_PRICE = 'before_price',
  AFTER_PRICE = 'after_price',
}

export const enum CurrencyCode {
  EUR = 'EUR',
  GBP = 'GBP',
  INR = 'INR',
  USD = 'USD',
  THB = 'THB',
}

export const enum CurrencySymbolOrCode {
  SYMBOL = 'symbol',
  CODE = 'code',
}

export interface CurrencyConfig {
  language: string;
  symbol: string;
  symbolPosition: CurrencyPosition;
  code: string;
  codePosition: CurrencyPosition;
  showSymbolOrCode: CurrencySymbolOrCode;
  decimals: number;
  // Use empty string for "Do not show decimal separator"
  decimalSeparator: string;
  // Use empty string for "Do not show thousand separator"
  thousandSeparator: string;
  // Use true to round of decimal price. eg - 10.65 > 11; (>=0.5)
  roundOff?: boolean;
}

export interface PreferenceServiceInterface {
  getPreferences: () => PrefernceType;
  setPreferences: (config: PrefernceType) => void;
}

declare global {
  // eslint-disable-next-line
  var PreferenceService: PreferenceServiceInterface;
  interface Window {
    PreferenceService: PreferenceServiceInterface;
  }
}
